import { cn, hasMessage } from "@/lib/utils";
import { MutableRefObject } from "react";

import { useChatMessages, useChatInteract } from "@chainlit/react-client";

import MessageComposer from "./MessageComposer";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "../ui/tooltip";
import { Button } from "../ui/button";
import { EditSquare } from "../icons/EditSquare";

interface Props {
  autoScrollRef: MutableRefObject<boolean>;
  showIfEmptyThread?: boolean;
}

export default function ChatFooter({ showIfEmptyThread, ...props }: Props) {
  const { messages } = useChatMessages();
  const { clear } = useChatInteract();

  if (!hasMessage(messages) && !showIfEmptyThread) return null;

  const handleNewChatBtnClick = () => {
    clear();
  };

  return (
    <div
      className={cn(
        "footer-compose-message relative flex flex-row items-center gap-5 w-full"
      )}
    >
      <MessageComposer {...props} />
      <TooltipProvider delayDuration={200}>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              size="icon"
              className="h-12 w-12 new-chat-btn"
              onClick={handleNewChatBtnClick}
            >
              <EditSquare className="!size-6" />
            </Button>
          </TooltipTrigger>
          <TooltipContent>
            <p>New Chat</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  );
}
